import React from 'react';
import {
  useGetComplianceChecklistQuery,
} from '../../../../../generated/core-api/graphql-react-query';
import { getProjectTrigger } from '../../../../Components/MainWindow/Components/Pages/CommandPage/Hooks/useCommands';
import useSessionStoreContext from '../SessionStoreContextProvider/useSessionStoreContext';
import useComplianceSubscription from './useComplianceSubscription';

export default function useSessionCompliance() {
  const {
    sessionId: [sessionId],
    detectionHistory: [detectionHistory],
  } = useSessionStoreContext();

  useComplianceSubscription(sessionId);

  const checklist = useGetComplianceChecklistQuery(
    { input: { id: sessionId ?? '' } },
    { enabled: !!sessionId },
  );

  const formattedChecklist = React.useMemo(() => {
    if (!checklist.data) return [];
    return checklist.data?.getSession.complianceChecklist.items
      .map((checklistItem) => ({
        ...checklistItem.mandatoryTopic,
        requiredAt: checklistItem.date,
        validatingCommands: checklistItem.mandatoryTopic.projectVocalTriggers?.items.map((command) => ({
          command: getProjectTrigger(command),
          isDetected: !!detectionHistory.some((detection) => detection.commandId === getProjectTrigger(command)?.id),
        })),
        rejectingCommands: checklistItem.mandatoryTopic.forbiddenCommands.map((command) => ({
          command: command.command,
          isDetected: !!detectionHistory.some((detection) => detection.commandId === command.command.id),
        })),
        result: checklistItem.status,
      }))
      .sort((a, b) => {
        if (a.result === b.result) return b.requiredAt - a.requiredAt;
        if (a.result === null) return -1;
        if (b.result === null) return 1;
        if (a.result) return -1;
        return 1;
      });
  }, [checklist.data, detectionHistory]);
  return formattedChecklist;
}
